import AxiosConfig from '@/config/axios-config'

export const PerfilAPI = {

  obterPerfil () {
    return AxiosConfig.secureJalekoAPI().get('/perfil').then(response => response.data)
  },

  atualizarMeusDadosFaculdade (id, anoInicio, semestreInicio, periodo) {
    return AxiosConfig.secureJalekoAPI().post('/perfil/editarFaculdade', { faculdade_id: id, ano_inicio: anoInicio, semestre_inicio: semestreInicio, periodo: periodo }).then(response => response.data)
  },

  listarFaculdades () {
    return AxiosConfig.secureJalekoAPI().get('/perfil/listarFaculdade').then(response => response.data)
  },

  atualizarDadosPessoais (nome, dataNascimento, cpf, telefone, infoExtra) {
    return AxiosConfig.secureJalekoAPI().post('/perfil/editarDadosPessoais', { name: nome, data_nascimento: dataNascimento, cpf: cpf, telefone: telefone, informacao_extra: infoExtra }).then(response => response.data)
  },

  alterarSenha (senha, novaSenha, confirmacaoSenha) {
    return AxiosConfig.secureJalekoAPI().post(`/perfil/editarSenha`, { senhaAntiga: senha, senhaNova: novaSenha, confSenhaNova: confirmacaoSenha }).then(response => response.data)
  },

  listarMeusCadernos (idCategoria, dataInicio, dataFim) {
    let url = '/perfil/caderno'
    if (idCategoria) {
      url += `/cat/${idCategoria}`
    }

    if (dataInicio) {
      url += `/ini/${dataInicio}`
    }

    if (dataFim) {
      url += `/fim/${dataFim}`
    }

    return AxiosConfig.secureJalekoAPI().get(url).then(response => response.data)
  },

  editarFoto (imagemSelecionada) {
    let formData = new FormData()
    formData.append('imagemUpload', imagemSelecionada)
    return AxiosConfig.secureJalekoAPI().post(`/perfil/editarFoto`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => response.data)
  }

}

export default PerfilAPI
